module.exports = __webpack_public_path__ + "static/reigas_imgs_1_Pernos-5ebbf3fdf14393b1c94fd239ab595187.png";